import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { actions } from '../../../context';

const FilterType = {
    Instance: 'instance',
    PIMS: 'pims',
};

const FilterForm = (props) => {
    const { closeBehavior, addFilterBehavior, filterToEdit = null } = props;

    const [filterToAdd, setFilterToAdd] = useState(
        filterToEdit ?? {
            filterType: '',
            filterData: [],
        }
    );
    const [instancesTextArea, setInstancesTextArea] = useState(
        filterToEdit !== null && filterToEdit.filterType === 'instance'
            ? {
                  value: filterToEdit.filterData.join(',\n'),
                  isInvalid: false,
              }
            : {
                  value: '',
                  isInvalid: false,
              }
    );
    const [pimses, setPimses] = useState([]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.pims.getAllPims()).then((res) =>
            setPimses(res?.data || [])
        );
    }, [dispatch]);

    const onMultiFilterDataChange = (e) => {
        let opts = [],
            opt;
        for (let i = 0, len = e.target.options.length; i < len; i++) {
            opt = e.target.options[i];
            if (opt.selected) {
                opts.push(opt.value);
            }
        }
        setFilterToAdd({ ...filterToAdd, filterData: opts });
    };

    const onFilterTypeChange = (e) =>
        setFilterToAdd({
            filterType: e.target.value,
            filterData: '',
        });

    const onFilterDataChange = (e) => {
        let splitText = e.target.value.split(',');

        var isGuidInvalid = AreValidGuids(splitText);

        setInstancesTextArea({
            value: e.target.value,
            isInvalid: isGuidInvalid,
        });

        splitText = splitText.map((el) => el.trim().toLowerCase());
        setFilterToAdd({ ...filterToAdd, filterData: splitText });
    };

    const closeClickHandler = () => {
        resetStateToDefault();
        closeBehavior();
    };

    const submitClickHandler = () => {
        addFilterBehavior(filterToAdd);
        resetStateToDefault();
        closeBehavior();
    };

    const resetStateToDefault = () => {
        setFilterToAdd({
            filterType: '',
            filterData: '',
        });
        setInstancesTextArea({
            value: '',
            isInvalid: false,
        });
    };

    const GetFilterSpecificForm = (filterType) => {
        switch (filterType) {
            case FilterType.Instance:
                return (
                    <FormGroup>
                        <Label>Instance Ids (comma seperated)</Label>
                        <Input
                            type="textarea"
                            value={instancesTextArea.value}
                            rows="15"
                            {...(instancesTextArea.isInvalid && {
                                style: { background: 'var(--warning)' },
                            })}
                            onChange={onFilterDataChange}></Input>
                    </FormGroup>
                );
            case FilterType.PIMS:
                return (
                    <FormGroup>
                        <Label>
                            {'Pims (ctrl + click to select multiple)'}
                        </Label>
                        <Input
                            type="select"
                            multiple
                            size={15}
                            onChange={onMultiFilterDataChange}>
                            <option disabled selected value>
                                -- select a filter --
                            </option>
                            {pimses.map((pims) => (
                                <option
                                    selected={filterToAdd.filterData.includes(
                                        pims.name
                                    )}
                                    value={pims.name}>
                                    {pims.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                );
            default:
                return;
        }
    };

    return (
        <Form>
            <FormGroup>
                <Label>Filter Type</Label>
                {filterToEdit !== null ? (
                    <Input type="select">
                        <option selected value={filterToEdit.filterType}>
                            {filterToEdit.filterType}
                        </option>
                    </Input>
                ) : (
                    <Input type="select" onChange={onFilterTypeChange}>
                        <option disabled selected value>
                            -- select a filter --
                        </option>
                        <option value={FilterType.Instance}>InstanceId</option>
                        <option value={FilterType.PIMS}>PIMS</option>
                    </Input>
                )}
            </FormGroup>
            {GetFilterSpecificForm(filterToAdd.filterType)}
            <FormGroup>
                <Button color="secondary" onClick={() => closeClickHandler()}>
                    Close
                </Button>{' '}
                <Button
                    color="primary"
                    disabled={
                        filterToAdd.filterType === FilterType.Instance &&
                        instancesTextArea.isInvalid
                    }
                    onClick={() => submitClickHandler()}>
                    Submit
                </Button>
            </FormGroup>
        </Form>
    );
};

function AreValidGuids(splitText) {
    var pattern =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    var isGuidInvalid = false;
    splitText.forEach((element) => {
        if (!pattern.test(element.trim())) {
            isGuidInvalid = true;
        }
    });
    return isGuidInvalid;
}

export default FilterForm;
